var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBackdropMiddle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 841,
    height: 750,
    viewBox: "0 0 841 750",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter0_f_1_7597)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 420.5,
    cy: 420.5,
    r: 120.5,
    fill: "#04D9FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1_7597",
    x: 0,
    y: 0,
    width: 841,
    height: 841,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150,
    result: "effect1_foregroundBlur_1_7597"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackdropMiddle);
export default __webpack_public_path__ + "static/media/backdrop-middle.50adedc50c38fa5ad7599c21955d0d90.svg";
export { ForwardRef as ReactComponent };